module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/qualification-input/qualification-input-grid/qualification-input-grid.component.css
// module id = ./src/app/hrms/serviceregister/qualification-input/qualification-input-grid/qualification-input-grid.component.css
// module chunks = main